import DataTableRowManagement from './data_table_row_management';
import DataTableView from './data_table_view';
import DataTable from 'frappe-datatable';
import './base.scss';

export const baseRowManagementController = (controller, rowBuilder, dataTableDependencies) => {
  Object.assign(controller, {
    initTable(){
      this.dataTableApi.freeze();
      this.dataTableApi.showToastMessage('Linhas sendo carregadas', 300);
      this.dataTableRowManagement.clean();
      this.dataTableApi.refresh([]);
    },

    rowLoaded({ detail: { row, errors } }){
      this.dataTableRowManagement.build(row, errors);
    },

    buildTable({detail}){
      this.dataTableApi.unfreeze();
      this.dataTableApi.clearToastMessage();
      this.dataTableView.showTableContainer();
      this.dataTableApi.setDimensions();
      this.refresh(
        detail?.rows || this.dataTableRowManagement.renderRows(),
        detail?.fileSize || 0
      );
    },

    filterFaultyRows(){
      let faultyRows = this.dataTableApi.datamanager.data.filter((row) => {
        return row.some((cell) => cell['editable'])
      });
      this.refresh(faultyRows);
    },

    submit({ detail: { fileInput, fileName } }){
      let csvContent = this.dataTableRowManagement.parsedCsvContent(fileName);
      let file       = this.createFile(fileName, csvContent);
      this.attachFile(fileInput, file);

      if(this.isFileOverSizeLimit(file.size)){
        this.submitUnderConfirmation(fileInput);
      }else{
        this.customSubmit(fileInput);
      }
    },

    submitUnderConfirmation(fileInput){
      if(confirm('Esse arquivo é muito grande. Tem certeza que deseja enviá-lo?')){
        this.customSubmit(fileInput);
      }
    },

    async customSubmit(fileInput){
      let form = fileInput.form
      form.setAttribute('enctype', 'multipart/form-data');
      form.submit();
    },

    refresh(rows, fileSize){
      this.dataTableApi.refresh(rows);
      this.dataTableView.highlightFaultyRows();
      this.dataTableView.setFileSize(fileSize);
    },

    createFile(fileName, csvContent){
      let blobs = new Blob(csvContent, {type: 'text/csv;charset=utf-8;'});
      let file = new File([blobs], fileName, {type: 'text/csv'});

      return file;
    },

    attachFile(fileInput, file){
      let fileTransfer = new DataTransfer();
      fileTransfer.items.add(file);

      fileInput.files = fileTransfer.files;
    },

    isFileOverSizeLimit(fileSize){
      return fileSize > this.rowBuilder.fileSizeLimit;
    }
  })

  initDependencies(controller, rowBuilder, dataTableDependencies)
};

function initDependencies(controller, rowBuilder, dataTableDependencies){
  addCollaborator(controller, rowBuilder)
  initDataTableApi(controller, dataTableDependencies)
  addListeners(controller);
}

function addCollaborator(controller, rowBuilder){
  let dataTableRowManagement = new DataTableRowManagement(rowBuilder);

  controller.rowBuilder = rowBuilder;
  controller.dataTableRowManagement = dataTableRowManagement;
  controller.dataTableView = new DataTableView({
    manager: dataTableRowManagement,
    rowRenderer: rowBuilder.renderer
  });
}

function initDataTableApi(controller, { dataContainerTargetName, columnsValueName, noDataValueName }){
  controller.dataTableApi = new DataTable(controller[`${dataContainerTargetName}Target`], {
    columns: controller.dataTableView.buildColumns(controller[`${columnsValueName}Value`]),
    layout: 'fluid',
    inlineFilters: true,
    noDataMessage: controller[`${noDataValueName}Value`],
    data: [],
    getEditor: controller.dataTableView.cellEditor()
  })
}

function addListeners(controller){
  document.addEventListener('batch-upload:parse-started', controller.initTable.bind(controller));
  document.addEventListener('batch-upload:row-load', controller.rowLoaded.bind(controller));
  document.addEventListener('batch-upload:parse-complete', controller.buildTable.bind(controller));
  document.addEventListener('batch-upload:rebuild', controller.buildTable.bind(controller));
  document.addEventListener('batch-upload:rows-submit', controller.submit.bind(controller));
}
